<p-card [header]="texts.titulo" [style]="{ width: '100%' }" *ngIf="pessoaId">
    <div class="customer-card">
        <div class="customer-header">
            <img src="https://via.placeholder.com/50" alt="Profile" class="profile-img" />
            <span class="customer-name">{{itemName}}</span>
        </div>
        <hr />
        <div class="customer-info">
            <!-- <div class="info-item">
                <i class="pi pi-shopping-cart icon"></i>
                <span>Quantidade de Vendas: {{pessoaValores.quantidadeVendas}} </span>
            </div>
            <div class="info-item text">
                <i class="pi pi-wallet icon"></i>
                <span>Total de Vendas: {{pessoaValores.totalVendas ? pessoaValores.totalVendas : 0}} $</span>
            </div>
            <div class="info-item">
                <i class="pi pi-shopping-cart icon"></i>
                <span>Quantidade de Compras: {{pessoaValores.quantidadeCompras}} </span>
            </div>
            <div class="info-item text">
                <i class="pi pi-wallet icon"></i>
                <span>Total de Compras: {{pessoaValores.totalCompras ? pessoaValores.totalCompras : 0}} $</span>
            </div> -->
        </div>
    </div>
</p-card>
